import { createReducer, on } from '@ngrx/store';
import { reportAncestryActions } from './ancestry.actions';
import { reportAncestryState } from './ancestry.state';

export const reportAncestryReducer = createReducer(
  reportAncestryState,
  on(reportAncestryActions.fetchReportLineage, (state) => ({
    ...state,
    reportLineageQuery: {
      ...state.reportLineageQuery,
      loading: true,
      error: undefined,
      fetchCount: state.reportLineageQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchReportLineageSuccess, (state, { data }) => ({
    ...state,
    reportLineageQuery: {
      ...state.reportLineageQuery,
      loading: false,
      data: data,
      error: undefined
    }
  })),
  on(reportAncestryActions.fetchReportLineageFailed, (state, { error }) => ({
    ...state,
    reportLineageQuery: {
      ...state.reportLineageQuery,
      loading: false,
      error: error
    }
  })),
  on(reportAncestryActions.fetchReportModern, (state) => ({
    ...state,
    reportModernQuery: {
      ...state.reportModernQuery,
      loading: true,
      error: undefined,
      fetchCount: state.reportModernQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchReportModernSuccess, (state, { data }) => ({
    ...state,
    reportModernQuery: {
      ...state.reportModernQuery,
      loading: false,
      data: data,
      error: undefined
    }
  })),
  on(reportAncestryActions.fetchReportModernFailed, (state, { error }) => ({
    ...state,
    reportModernQuery: {
      ...state.reportModernQuery,
      loading: false,
      error: error
    }
  })),
  on(reportAncestryActions.fetchReportAncient, (state) => ({
    ...state,
    reportAncientQuery: {
      ...state.reportAncientQuery,
      loading: true,
      error: undefined,
      fetchCount: state.reportAncientQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchReportAncientSuccess, (state, { data }) => ({
    ...state,
    reportAncientQuery: {
      ...state.reportAncientQuery,
      loading: false,
      data: data,
      error: undefined
    }
  })),
  on(reportAncestryActions.fetchReportAncientFailed, (state, { error }) => ({
    ...state,
    reportAncientQuery: {
      ...state.reportAncientQuery,
      loading: false,
      error: error
    }
  })),
  on(reportAncestryActions.fetchReportAncientVisibility, (state) => ({
    ...state,
    reportAncientVisibilityQuery: {
      ...state.reportAncientVisibilityQuery,
      loading: true,
      fetchCount: state.reportAncientVisibilityQuery.fetchCount + 1,
      error: undefined
    }
  })),
  on(
    reportAncestryActions.fetchReportAncientVisibilitySuccess,
    (state, { status }) => ({
      ...state,
      reportAncientVisibilityQuery: {
        ...state.reportAncientVisibilityQuery,
        loading: false,
        status
      }
    })
  ),
  on(
    reportAncestryActions.fetchReportAncientVisibilityFailed,
    (state, { error }) => ({
      ...state,
      reportAncientVisibilityQuery: {
        ...state.reportAncientVisibilityQuery,
        loading: false,
        error
      }
    })
  ),
  on(reportAncestryActions.fetchReportContinentColors, (state) => ({
    ...state,
    continentColorsQuery: {
      ...state.continentColorsQuery,
      loading: true,
      error: undefined,
      fetchCount: state.continentColorsQuery.fetchCount + 1
    }
  })),
  on(
    reportAncestryActions.fetchReportContinentColorsSuccess,
    (state, { data }) => ({
      ...state,
      continentColorsQuery: {
        ...state.continentColorsQuery,
        loading: false,
        data: data,
        error: undefined
      }
    })
  ),
  on(
    reportAncestryActions.fetchReportContinentColorsFailed,
    (state, { error }) => ({
      ...state,
      continentColorsQuery: {
        ...state.continentColorsQuery,
        loading: false,
        error: error
      }
    })
  ),
  on(reportAncestryActions.fetchContinentStyles, (state) => ({
    ...state,
    continentStylesQuery: {
      ...state.continentStylesQuery,
      loading: true,
      error: undefined,
      fetchCount: state.continentStylesQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchContinentCoordinates, (state) => ({
    ...state,
    continentCoordinatesQuery: {
      ...state.continentCoordinatesQuery,
      loading: true,
      error: undefined,
      fetchCount: state.continentCoordinatesQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchUnM49Region, (state) => ({
    ...state,
    unM49RegionQuery: {
      ...state.unM49RegionQuery,
      loading: true,
      error: undefined,
      fetchCount: state.unM49RegionQuery.fetchCount + 1
    }
  })),
  on(reportAncestryActions.fetchContinentStylesSuccess, (state, { data }) => ({
    ...state,
    continentStylesQuery: {
      ...state.continentStylesQuery,
      loading: false,
      data: data,
      error: undefined
    }
  })),
  on(reportAncestryActions.fetchContinentStylesFailed, (state, { error }) => ({
    ...state,
    continentStylesQuery: {
      ...state.continentStylesQuery,
      loading: false,
      error: error
    }
  })),
  on(
    reportAncestryActions.fetchContinentCoordinatesSuccess,
    (state, { data }) => ({
      ...state,
      continentCoordinatesQuery: {
        ...state.continentCoordinatesQuery,
        loading: false,
        data: data,
        error: undefined
      }
    })
  ),
  on(
    reportAncestryActions.fetchContinentCoordinatesFailed,
    (state, { error }) => ({
      ...state,
      continentCoordinatesQuery: {
        ...state.continentCoordinatesQuery,
        loading: false,
        error: error
      }
    })
  ),
  on(reportAncestryActions.fetchUnM49RegionSuccess, (state, { data }) => ({
    ...state,
    unM49RegionQuery: {
      ...state.unM49RegionQuery,
      loading: false,
      data: data,
      error: undefined
    }
  })),
  on(reportAncestryActions.fetchUnM49RegionFailed, (state, { error }) => ({
    ...state,
    unM49RegionQuery: {
      ...state.unM49RegionQuery,
      loading: false,
      error: error
    }
  })),
  on(reportAncestryActions.resetUserReportData, (state) => ({
    ...reportAncestryState,
    continentColorsQuery: state.continentColorsQuery,
    continentStylesQuery: state.continentStylesQuery,
    continentCoordinatesQuery: state.continentCoordinatesQuery,
    unM49RegionQuery: state.unM49RegionQuery,
    home: {
      ...reportAncestryState.home,
      maps: state.home.maps
    }
  })),
  on(
    reportAncestryActions.setHomeModernSelectedContinentCode,
    (state, { code }) => ({
      ...state,
      home: {
        ...state.home,
        modern: {
          ...state.home.modern,
          selectedContinentCode: code
        }
      }
    })
  ),
  on(reportAncestryActions.startHomeMapsLoading, (state) => ({
    ...state,
    home: {
      ...state.home,
      maps: {
        ...state.home.maps,
        status: {
          ...state.home.maps.status,
          loadCount: state.home.maps.status.loadCount + 1,
          loading: true,
          error: null
        }
      }
    }
  })),
  on(reportAncestryActions.startHomeMapsLoadingSuccess, (state) => ({
    ...state,
    home: {
      ...state.home,
      maps: {
        ...state.home.maps,
        status: {
          ...state.home.maps.status,
          loading: false,
          rendered: true,
          error: null
        }
      }
    }
  })),
  on(reportAncestryActions.startHomeMapsLoadingFailed, (state, { error }) => ({
    ...state,
    home: {
      ...state.home,
      maps: {
        ...state.home.maps,
        status: {
          ...state.home.maps.status,
          loading: false,
          error: error
        }
      }
    }
  })),
  on(reportAncestryActions.clearHomeMapsStatus, (state) => ({
    ...state,
    home: {
      ...state.home,
      maps: {
        ...state.home.maps,
        status: {
          ...reportAncestryState.home.maps.status
        }
      }
    }
  }))
);
